import { makePostRequest } from 'owa-ows-gateway';
import { UserSubscriptionResponse } from './UserSubscriptionResponse';

const POST_SUBSCRIPTION_URL: string = 'ows/api/beta/PremiumSubscription';

export async function fetchUserSubscription(): Promise<UserSubscriptionResponse> {
    return makePostRequest(POST_SUBSCRIPTION_URL, null);
}
